const emailRegEx = /^([\w-]+(?:[.+][\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
const validationsMap = {
    email: value => emailRegEx.test(value),
    minLength: (value, fieldConfig) => value.length >= fieldConfig.validations.minLength,
    required: value => !!value
};
const shortMsgLangCodes = ['ko', 'ja', 'th', 'zh', 'zh_CN'];
const defaultMsgMinLength = 30;
const shortMsgMinLength = 15;

function getMsgMinLength(lang) {
    if (shortMsgLangCodes.includes(lang)) {
        return shortMsgMinLength;
    } else {
        return defaultMsgMinLength;
    }
}

export default {
    isValid: (fieldConfig, currentValue) => {
        const escapedValue = currentValue.trim();
        return (!fieldConfig.validations.required && !escapedValue) || Object.keys(fieldConfig.validations).every(validationKey => {
            return !fieldConfig.validations[validationKey] || !validationsMap[validationKey] || validationsMap[validationKey](escapedValue, fieldConfig);
        });
    },
    isValidMsg: function (currentValue, currentLang) {
        return this.isValid({
            validations: {
                required: true,
                minLength: getMsgMinLength(currentLang)
            }
        }, currentValue);
    }
};


// WEBPACK FOOTER //
// ./src/fieldValidation.js